import Vue from 'vue'
import Vuex from 'vuex'

import main from './modules/store.main'
import cart from './modules/store.cart'
import search from './modules/store.search'

Vue.config.devtools = true
Vue.use(Vuex)

const store = {
    modules: {
        main,
        cart,
        search
    }
}

const Store = new Vuex.Store(store)

export default Store